export type AppUpdateNotice = {
  state: 'checking' | 'available' | 'downloading' | 'ready' | 'applying' | 'applied' | 'current' | 'error' | 'offline'
  message: string; version?: string; currentVersion?: string; progress?: number; source?: 'web' | 'android'
  errorCode?: string; applyBlockedReason?: string; nativeVersion?: string; nativeVersionCode?: number; recoverable?: boolean; stage?: string
}
let status: AppUpdateNotice = { state: 'current', message: '새 버전은 자동으로 확인해요.' }
const listeners = new Set<() => void>()
const states = ['checking', 'available', 'downloading', 'ready', 'applying', 'applied', 'current', 'error', 'offline']
function accept(value: AppUpdateNotice) {
  if (!value || !states.includes(value.state) || typeof value.message !== 'string') return
  status = { ...value, progress: typeof value.progress === 'number' && Number.isFinite(value.progress) ? Math.max(0, Math.min(100, value.progress)) : undefined }
  listeners.forEach(listener => listener())
}
if (typeof window !== 'undefined') window.addEventListener('lulla-app-update', event => accept((event as CustomEvent<AppUpdateNotice>).detail))
export function publishAppUpdate(notice: AppUpdateNotice) {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('lulla-app-update', { detail: notice }))
  else accept(notice)
}
export const getAppUpdateState = () => status
export const subscribeAppUpdates = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener) } }
